import { render } from "./RegisterVue.vue?vue&type=template&id=d52b9acc"
import script from "./RegisterVue.vue?vue&type=script&lang=js"
export * from "./RegisterVue.vue?vue&type=script&lang=js"

import "./RegisterVue.vue?vue&type=style&index=0&id=d52b9acc&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__